<template>
  <App>
    <div v-if="!processing">
      <div class="alert alert-primary d-flex align-items-center p-5 mb-10">
        <span class="svg-icon svg-icon-2hx svg-icon-primary me-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="black"></path>
            <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path>
          </svg>
        </span>
        <div class="d-flex flex-column">
          <h4 class="mb-1 text-primary">Situação da avaliação</h4>
          <span v-if="projetosPaginated[0].avaliar === 'P'">Olá Avaliador(a), neste momento você está avaliando a estrutura inicial do projeto.</span>
          <span v-if="projetosPaginated[0].avaliar === 'R'">Olá Avaliador(a), neste momento você está avaliando o resumo do projeto.
            Seja criterioso(a) em sua avaliação.</span>
        </div>
      </div>
      <div class="row">
        <div class="col-4 mb-3" v-for="avaliacao in projetosPaginated">
          <div class="card border-hover-primary">
              <div class="card-header ribbon ribbon-top pt-9">
                <div class="ribbon-label bg-success fw-bolder" v-if="avaliacao.situacao === 3">Aprovado</div>
                <div class="ribbon-label bg-danger fw-bolder" v-if="avaliacao.situacao === 4">Reprovado</div>
                <div class="ribbon-label bg-success fw-bolder" v-if="avaliacao.situacao === 1 || avaliacao.situacao === 10">Aprovado com Reformulações</div>
                <div class="ribbon-label bg-info fw-bolder"
                     data-bs-toggle="tooltip"
                     data-bs-trigger="hover"
                     data-bs-original-title="O(a) Orientador(a) está prosseguindo com as devidas correções, em breve você será notificado(a) por e-mail."
                     v-if="avaliacao.situacao === 5">Corrigindo</div>
                <div class="ribbon-label bg-primary fw-bolder" v-if="avaliacao.situacao === 0">Pendente de Avaliação</div>
                <div class="ribbon-label bg-primary fw-bolder" v-if="avaliacao.situacao === 2">Pendente de Reavaliação</div>
                <div class="ribbon-label bg-warning fw-bolder" v-if="avaliacao.situacao === 99">Indisponível para Avaliação</div>

                <div class="card-title flex-column">
                  <div class="fs-5 fw-bolder text-dark">Projeto</div>
                  <span class="text-gray-400 fw-bold fs-6 mt-1 mb-7 h-45px">{{ avaliacao.projeto.nome }}</span>
                </div>
              </div>
            <div class="card-body p-9">
              <div class="row mb-4">
                <div class="col-12">
                  <div class="border border-gray-300 border-dashed rounded min-w-125px p-2 mb-3">
                    <div class="fs-6 text-gray-800 fw-bolder">Categoria</div>
                    <div class="text-gray-400">{{ avaliacao.projeto.categoria.nome }}</div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-8 text-center">
                  <div class="separator separator-content border-primary my-3">Alunos</div>

                  <div class="symbol-group symbol-hover">
                    <div v-for="aluno in avaliacao.projeto.alunos" class="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip" title="" :data-bs-original-title="aluno.nome">
                      <span class="symbol-label bg-primary text-inverse-primary fw-bolder">{{ aluno.nome.substring(0, 1) }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-4 d-flex align-items-center justify-content-end">
                  <Link :href="this.route('app.projetos.avalia-projeto', {id: avaliacao.id})"
                        method="get"
                        class="btn btn-sm btn-success" v-if="(avaliacao.correcoes < 1 || (avaliacao.situacao === 0 || avaliacao.situacao === 2)) && avaliacao.projeto.InscricaoResumo">
                      {{avaliacao.situacao === 2 ? 'Reavaliar' : 'Avaliar'}}
                  </Link>
                  <Link :href="this.route('app.projetos.avalia-projeto', {id: avaliacao.id})"
                        method="get"
                        v-else-if="!avaliacao.avaliacao_resumo.nota && avaliacao.projeto.InscricaoResumo && (avaliacao.situacao === 1 || avaliacao.situacao === 3)"
                        class="btn btn-sm btn-success">
                      Informar nota
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h4 v-if="loadingMore">Estamos buscando mais projetos...</h4>
    </div>
    <div v-else>
      <h4>Estamos buscando os projetos...</h4>
    </div>
  </App>
</template>
<script>
import App from "@layout/App";
import {Link} from "@inertiajs/inertia-vue3";
import SubmitButton from "@forms/SubmitButton";
import Datepicker from "@forms/Datepicker";
import FormGroup from "@forms/FormGroup";
import axios from "axios";

export default {
  props: ['projetos'],

  components: {
    FormGroup,
    Datepicker,
    SubmitButton,
    App,
    Link,
  },

  data: _ => ({
    avaliar: 'Projeto',
    projetosPaginated: [],
    processing: true,
    loadingMore: true
  }),

  mounted() {
    this.init();
  },

  computed: {
    pendentes() {
      return this.projetos.filter(p => p.situacao === 0 || p.situacao === 2).length
    }
  },
  methods: {
    init() {
      this.projetosPaginated.push(...this.projetos.data);
      this.loadProjetos(this.projetos.links.next)
    },

    escolaNome(nome) {
      return nome.length < 50 ? nome : nome.substring(0, 50) + '...'
    },

    loadProjetos (nextLink) {
      this.processing = false

      if (nextLink) {
        axios.get(nextLink).then(response => {
          this.projetosPaginated.push(...response.data.data)
          this.loadProjetos(response.data.links.next)
        })
      } else {
        this.avaliar = this.projetosPaginated[0].avaliar === 'R' ? 'Resumo' : 'Projeto'
        this.emitter.emit('title', 'Avaliar ' + this.avaliar);
        this.emitter.emit('breadcrumb', [
          {title: 'Dashboard', link: 'app.home'},
          {title: 'Avaliação'},
        ]);

        this.emitter.emit('action', {
            show: false,
          }
        );

        this.loadingMore = false
      }
    },
  },
};
</script>
